import { render, staticRenderFns } from "./LayoutElementSettingsMenu.vue?vue&type=template&id=30faa1b9&scoped=true"
import script from "./LayoutElementSettingsMenu.vue?vue&type=script&lang=js"
export * from "./LayoutElementSettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutElementSettingsMenu.vue?vue&type=style&index=0&id=30faa1b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30faa1b9",
  null
  
)

export default component.exports